export function buildScoreRequest({
  draft,
  taskBrief,
  researchTopic,
  references,
  cefrLevel,
}) {
  return {
    draft: String(draft || ''),
    task_brief: String(taskBrief || ''),
    research_topic: String(researchTopic || ''),
    references: Array.isArray(references) ? references : [],
    cefr_level: String(cefrLevel || ''),
  }
}
